import React from "react";
import { Link } from "react-router";
import Right from "../../../assets/img/icon/arrow-right2.svg";
import BlogsList from "./BlogList";

const ShowBlogs = (props) => {
  return (
    <>
      <section className="blog pt-135 pb-150">
        <div className="container">
          <div className="row align-items-end mb-10">
            <div className="col-lg-8">
              <div className="section-title mb-30">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  Blog Admin
                </span>
                <h3 className="title xb-split-text split-in-right">
                  Explore Blogs
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="faq-btn ul_li_right mb-30">
                <Link to="/blogs" className="btn-link ul_li_right">
                  See All Blogs{" "}
                  <span>
                    <img src={Right} alt="" />
                  </span>
                </Link>
              </div>
            </div>
          </div>

          <BlogsList setBlogId={props.setBlogId} />
        </div>
      </section>
    </>
  );
};

export default ShowBlogs;
